import "./ChartContainer.css";

export const ChartContainer: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    return <div className="chart-container">{children}</div>;
};
